var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_140891",
    "data-name": "Group 140891",
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    viewBox: "0 0 35 35",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_140890",
    "data-name": "Group 140890"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    fill: "#dbe448",
    stroke: "#fff",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 17.5,
    cy: 17.5,
    r: 17,
    fill: "none"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Icon_feather-download",
    "data-name": "Icon feather-download",
    transform: "translate(5.5 5.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_369580",
    "data-name": "Path 369580",
    d: "M19.536,22.5v3.341a1.671,1.671,0,0,1-1.671,1.671H6.171A1.671,1.671,0,0,1,4.5,25.841V22.5",
    transform: "translate(0 -7.976)",
    fill: "none",
    stroke: "#125bb2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369581",
    "data-name": "Path 369581",
    d: "M10.5,15l4.177,4.177L18.853,15",
    transform: "translate(-2.659 -4.653)",
    fill: "none",
    stroke: "#125bb2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369582",
    "data-name": "Path 369582",
    d: "M18,14.524V4.5",
    transform: "translate(-5.982)",
    fill: "none",
    stroke: "#125bb2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/Download.e9ab400c4ec80a31c05b4ca2d60332b2.svg";
export { ForwardRef as ReactComponent };